module.exports = __webpack_public_path__ + "media/assets/images/flags/wf-971e290e43b1dfeb9f8619c0bb4e8094.svg";